import React, { FC } from 'react';

import { BOLINDA_ICON_BOLINDA_ONLY } from '../common/Button/Icon';
import { NavigationLink } from '../navigation/NavigationLink';

import './MainNavigation.scss';
import { useTranslation } from 'react-i18next';
import { COLLECTION_NAVIGATION_V2, MULTI_LANGUAGE_SHOP, useFeature } from '../utils/togglz';

type Props = {
    readonly isCatalogueManagementAdmin: boolean;
};

const MainNavigation: FC<Props> = ({ isCatalogueManagementAdmin }) => {
    const { t } = useTranslation();

    return (
        <ul className="main-nav">
            <li>
                <ShopLink />
            </li>
            <li>
                <YourBorrowBoxLink />
            </li>
            {isCatalogueManagementAdmin && (
                <li>
                    <NavigationLink external={true} href="/cm">
                        <span className="main-nav-icon">
                            <i className="bolinda-icons">{BOLINDA_ICON_BOLINDA_ONLY}</i>
                            {t('menu.catalogue')}
                        </span>
                    </NavigationLink>
                </li>
            )}
        </ul>
    );
};

export default MainNavigation;

const SHOP_ALTERNATIVE_ROUTES = [
    '/libxchange', // TODO [multi-language-shop] legacy
    '/unlimited', // TODO [multi-language-shop] legacy
    '/language', // TODO [multi-language-shop] legacy
    '/assistant',
    '/orderlists',
    '/cart',
    '/checkout',
    '/orders',
    '/terms-conditions'
];

const ShopLink: FC = () => {
    const { t } = useTranslation();
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);

    return (
        <NavigationLink
            to={isMultiLanguageShopEnabled ? '/shop' : '/catalogue'}
            alternativeRoutes={SHOP_ALTERNATIVE_ROUTES}
        >
            {t('menu.shopMain')}
        </NavigationLink>
    );
};

const YOUR_BORROWBOX_ALTERNATIVE_ROUTES = [
    '/localcontent',
    '/marketing',
    '/merchandising',
    '/usermanagement',
    '/reporting'
];

const YourBorrowBoxLink: FC = () => {
    const { t } = useTranslation();
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);

    return (
        <NavigationLink
            to={isCollectionNavigationV2Enabled ? '/collectionmgmt' : '/collection'}
            alternativeRoutes={YOUR_BORROWBOX_ALTERNATIVE_ROUTES}
        >
            {t('menu.yourBorrowboxMain')}
        </NavigationLink>
    );
};
